import styled from 'styled-components';

export default styled.img`
  display: block;
  margin: 0 auto;
  width: auto;
  max-height: 45px;

  &:last-child {
    margin-top: 1rem;
  }
`;
